<template>
    <modal name="new_auto_investment_preset_modal" height="auto" :scrollable="true" :adaptive="true" :reset="true" @closed="onClose">
        <div class="modal-content">
            <div class="modal-header pt-3 pr-0">
                <div class="col-md-12 pr-3">
                    <i class="fa fa-times-circle pull-right" style="color:#000; cursor:pointer;" data-dismiss="modal" @click="onClose"></i>
                </div>
            </div>
            <div class="modal-body" style="padding: 5px 20px !important">
                <div class="row">
                    <div class="col-md-12 mb-3"><h3 class="mb-0 pull-left"><b>Hey {{this.user.first_name}},</b></h3></div>
                    <div class="col-md-12 mb-3" :class="[isMobile ? 'pull-left' : 'text-center']"><h4 class="mb-0"><b>Optimize your investments now!</b></h4></div>
                    <div class="col-md-12 mb-3" :class="[isMobile ? 'pull-left' : 'text-center']">Maximising passive returns conveniently.</div>
                    <div class="col-md-12 mb-4 d-flex flex-row justify-content-center">
                        <div class="col-md-10 col-xs-12" :style="[isMobile ? {'font-size':'11px'} : '']">
                            <table class="financial_table text-center" style="">
                                <tr>
                                    <td class="pb-0 text-left" style="width:30%;"><b>Type of Financing</b></td>
                                    <td class="pb-0">Term Financing, Invoice Financing &amp; Contract Financing</td>
                                </tr>
                                <tr>
                                    <td class="pb-0 text-left"><b>Investment Amount</b></td>
                                    <td class="pb-0">RM 50 - RM 200</td>
                                </tr>
                                <tr>
                                    <td class="pb-0 text-left"><b>Tenure</b></td>
                                    <td class="pb-0">Up to 12 months</td>
                                </tr>
                                <tr>
                                    <td class="pb-0 text-left"><b>Profit Rate</b></td>
                                    <td class="pb-0">Up to 12%</td>
                                </tr>
                                <tr>
                                    <td class="pb-0 text-left"><b>Type of Note</b></td>
                                    <td class="pb-0">Shariah &#38; Conventional</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer row" style="padding-bottom: 25px;">
                <div class="col-md-12 d-flex flex-row justify-content-center">
                    <button @click.prevent="createAutoInvestment" class="btn btn-success pt-2 pb-2" :disabled="loading">Start Your Auto Investment</button>
                </div>
                <div class="col-md-12 d-flex flex-row justify-content-center">
                    <label class="form-check-label">
                        <input class="form-check-input" type="checkbox" v-model="hideAutoInvestMessage"/>
                        <span class="form-check-sign"></span>
                        <small>Don't show this again</small>
                    </label>
                </div>
            </div>
        </div>
    </modal>
</template>
<script>
export default {
    name: 'AutoInvestmentPresetModal',
    props: {
        user: {
            type: Object,
        }
    },
    data () {
        return {
            hideAutoInvestMessage: false,
            loading: false,
            isMobile: null,
            maxWidth: 400,
        }
    },
    created () {
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    methods: {
        handleResize() {
            this.isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        },
        onClose () {
            if (this.hideAutoInvestMessage == true) {
                axios.get('/api/auto_investment_messsage/hide')
            }
            this.$emit('presetModalClose')
        },
        createAutoInvestment() {
            this.loading = true
            let formData = new FormData()
            formData.append('botName', 'My Auto Investment')
            formData.append('mode', 'create')
            formData.append('tenure_from', 1)
            formData.append('tenure_to', 12)
            formData.append('interest_from', 8)
            formData.append('interest_to', 12)
            formData.append('term_financing_amount_from', 50)
            formData.append('term_financing_amount_to', 200)
            formData.append('invoice_financing_payable_amount_from', 50)
            formData.append('invoice_financing_payable_amount_to', 200)
            formData.append('invoice_financing_receivable_amount_from', 50)
            formData.append('invoice_financing_receivable_amount_to', 200)
            formData.append('contract_financing_amount_from', 50)
            formData.append('contract_financing_amount_to', 200)
            formData.append('financingType', ['Term Financing', 'Invoice Financing - Payable', 'Invoice Financing - Receivable', 'Contract Financing'])
            formData.append('noteType', ['Conventional', 'Shariah'])
            axios.post('/api/settings/auto_bot_invest/create', formData)
                .then((res) => {
                    this.loading = false
                    if (res.data.success === true) {
                        if (this.hideAutoInvestMessage == true) {
                            axios.get('/api/auto_investment_messsage/hide')
                        }
                        this.$emit('presetModalClose')
                        this.$router.push({ name: 'auto_investment', params: { preset: true }})
                    }
                    if (res.data.success === true && res.data.exist === true) {
                        this.$noty.error('Error! You already have an existing auto investment.')
                        this.$emit('presetModalClose')
                        this.$router.push({ name: 'auto_investment', params: { preset: false }})
                    }
                })
                .catch ((error) => {
                    this.loading = false
                    this.$noty.error('Error! Please try again!')
                })
        },
    }
}
</script>
